import PropTypes from 'prop-types';

export default function PageCounter({ activePageIndex, totalPages }) {
  return (
    <div className="page-counter u-margin-m-right u-show-from-sm">
      <span className="page-current">{activePageIndex + 1}</span>
      <span className="u-margin-xs-hor">/</span>
      <span className="page-total">{totalPages}</span>
    </div>
  );
}

PageCounter.propTypes = {
  activePageIndex: PropTypes.number,
  totalPages: PropTypes.number,
};

PageCounter.defaultProps = {
  activePageIndex: 0,
  totalPages: 1,
};
